import { render, staticRenderFns } from "./screenFacturasNotas.vue?vue&type=template&id=53bb855c&scoped=true"
import script from "./screenFacturasNotas.vue?vue&type=script&lang=js"
export * from "./screenFacturasNotas.vue?vue&type=script&lang=js"
import style0 from "./screenFacturasNotas.vue?vue&type=style&index=0&id=53bb855c&prod&lang=css"
import style1 from "./screenFacturasNotas.vue?vue&type=style&index=1&id=53bb855c&prod&scoped=true&lang=css"
import style2 from "./screenFacturasNotas.vue?vue&type=style&index=2&id=53bb855c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb855c",
  null
  
)

export default component.exports